import { render, staticRenderFns } from "./SummaryNameList.vue?vue&type=template&id=a853ed12&"
import script from "./SummaryNameList.vue?vue&type=script&lang=js&"
export * from "./SummaryNameList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports